.hearing-language-support-step{display:flex;flex-direction:column;gap:24px;max-width:480px}
/*# sourceMappingURL=hearing-language-support-step.component-6JPVJIEW.css.map */
